/**
 * OwalSearchPredicate.js
 *
 * @description A predicate defines a set of search conditions.
 *
 * > the part of a sentence or clause containing a verb and stating something about the subject (e.g., went home in John
 * > went home): [as modifier] : predicate adjective.
 *
 * Source: Apple Dictionary
 *
 * In this case, a predicate applies to one or more Object keys, and tells us something about the object.
 * For example: User's first name contains "Jo". In code, this would look something like this:
 *
 * const searchTerm = 'Jo'
 * const keys = ['name']
 * const matchConditions OwalSearchMatchCondition.EQUALS
 * const predicate = new OwalUI.OwalSearchPredicate(searchTerm, keys, matchCondition)
 *
 */

import { OwalSearchMatchCondition } from './OwalSearchMatchCondition'

/**
 * An encapsulation around a search term and what fields it applies to.
 *
 * @class OwalSearchPredicate
 */

export class OwalSearchPredicate {
  /**
   * Creates an instance of OwalSearchTerm.
   * @param {Array<String>} searchKeys The properties to search. (Passing in an empty array is undefined behavior, right now.)
   * @param {OwalSearchMatchCondition} matchCondition Specifies if the predicate requires an exact match, beginning match, etc to be true.
   * @param {Bool} caseSensitive Specifies if the search is case sensitive. false by default.
   * @memberof OwalSearchPredicate
   */
  constructor ({ searchKeys = [], matchCondition = OwalSearchMatchCondition.INCLUDES, caseSensitive = false }) {
    this.searchKeys = searchKeys
    this.matchCondition = matchCondition
    this.caseSensitive = caseSensitive
    // console.debug(`Create search predicate with keys: ${searchKeys}`)
  }

  /**
   * Checks if the predicate is a compound predicate or not.
   *
   * @memberof OwalSearchPredicate
   */
  get isCompoundPredicate () {
    return false
  }
}
